export default "__VITE_ASSET__Bs1CA4xw__"